import { useState } from "react";
import classNames from "classnames";
import { DocumentationPerspective } from "../../../documentation/DocumentationPerspectiveSelector";
import { usePageState } from "../../context/usePageState";
import { usePanelPageTitles } from "../PanelPageContext";
import { HelpDocumentBody } from "./HelpDocumentBody";
import { HelpOverview } from "./HelpOverview";
import { useHelpDocuments } from "./useHelpDocuments";

const perspectives = [
  {
    value: DocumentationPerspective.ClientAdministrator,
    label: "Client view",
  },
  {
    value: DocumentationPerspective.Administrator,
    label: "Administrator view",
  },
];

export function HelpDocumentPanel() {
  const { hasAnyRole } = usePageState();
  const { documents, selected } = useHelpDocuments();
  const isAdministrator = hasAnyRole(["administrator"]);
  const [perspective, setPerspective] = useState<string>(
    isAdministrator
      ? DocumentationPerspective.Administrator
      : DocumentationPerspective.ClientAdministrator
  );

  usePanelPageTitles({
    page: selected && `Help - ${selected.title}`,
    back: selected && { route: "/help", title: "Back to help" },
  });

  return (
    <>
      {isAdministrator && (
        <section className="card mb-4">
          <div className="card-body">
            <h2 className="h5 fw-bold mb-2">Documentation perspective</h2>
            <p className="text-muted mb-3">
              Administrators can switch view to confirm what client
              administrators can see.
            </p>
            <div className="btn-group" role="group" aria-label="View as">
              {perspectives.map(({ value, label }) => (
                <button
                  key={value}
                  type="button"
                  className={classNames("btn", {
                    "btn-primary": perspective === value,
                    "btn-outline-primary": perspective !== value,
                  })}
                  onClick={() => setPerspective(value)}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </section>
      )}
      {selected ? (
        <section className="card">
          <div className="card-body p-4 p-lg-5">
            <HelpDocumentBody
              key={selected.id}
              document={selected}
              perspective={perspective}
            />
          </div>
        </section>
      ) : (
        <HelpOverview documents={documents} />
      )}
    </>
  );
}
